import {Injectable} from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class DynamicIdService {
	ids: {[key: string]: number} = {};

	getId(slug: string) {
		if (!this.ids[slug]) this.ids[slug] = 0;
		this.ids[slug]++;
		return `${slug}-${this.ids[slug]}`;
	}
}
